import type { FC, SVGProps } from 'react';
import React from 'react';

type IconProps = SVGProps<SVGSVGElement>;

export const VolumeMutedIcon: FC<IconProps> = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9061 3.87817C11.0204 3.77472 11.1853 3.74906 11.3246 3.81128C11.4653 3.8735 11.5556 4.0135 11.5556 4.16672V15.8334C11.5556 15.9866 11.4653 16.1266 11.3246 16.1888C11.274 16.2114 11.2203 16.2223 11.1667 16.2223C11.0726 16.2223 10.9792 16.1881 10.9061 16.1219L7.13078 12.7207L4.94444 12.7223C4.30122 12.7223 3.77778 12.1988 3.77778 11.5556V8.4445C3.77778 7.80128 4.30122 7.27783 4.94444 7.27783H7.13389L10.9061 3.87817ZM16.4489 8.05717L16.9988 8.60706L15.605 10.0001L16.9988 11.3931L16.4489 11.9429L15.0551 10.5499L13.6621 11.9429L13.1122 11.3931L14.5052 10.0001L13.1122 8.60706L13.6621 8.05717L15.0551 9.45017L16.4489 8.05717Z"
      fill="white"
      fillOpacity="0.8"
    />
  </svg>
);
